<template>
  <q-btn
    v-bind="vAttrs"
    @click="captureImage"
  >
    <q-dialog
      v-model="showPhotoModal"
      maximized
    >
      <q-card>
        <q-card-section
          class="q-pa-none flex justify-center overflow-hidden full-height full-width"
          style="max-width: 100vw; max-height: 100vh;"
        >
          <video ref="video" />
          <!--          <div class="absolute-top text-right q-py-lg q-gutter-md">-->
          <!--            <q-toggle v-model="flash" icon="fa fa-bolt" size="xl" class="q-mx-none" color="yellow"/>-->
          <!--          </div>-->
          <div class="absolute-bottom text-center q-py-lg q-gutter-md">
            <q-btn
              fab
              round
              icon="fa fa-times"
              color="secondary"
              @click="cameraClose"
            />
            <q-btn
              fab
              round
              icon="fa fa-camera"
              color="primary"
              @click="cameraCapture"
            />
            <q-btn
              fab
              round
              icon="fa fa-sync-alt"
              color="secondary"
              @click="cameraRotate"
            />
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-btn>
</template>

<script>
import '@/utils/navigator/mediaDevices'
import { AGENTS_EMPTY_PICTURE } from '@/consts/agents'

/**
 * Bouton pour capturer une photo
 */
export default {
  name: 'BtnCamera',
  inheritAttrs: false,
  props: {
    /**
     * @model
     */
    value: {
      type: [Object, String],
      default: undefined
    }
  },
  data () {
    return {
      showPhotoModal: false,
      frontCamera: true,
      flash: false
    }
  },
  computed: {
    vAttrs () {
      return {
        round: true,
        icon: 'fa fa-camera',
        color: 'primary',
        ...this.$attrs
      }
    }
  },
  destroyed () {
    this._clearStream()
  },
  methods: {
    _clearStream () {
      this.stream && this.stream.getTracks().forEach((t) => t.stop())
    },
    _emitBouchon () {
      this.$q.notify(`Un bouchon à été mise en place`)
      this.$emit('input', {
        mimeType: `image/jpeg`,
        base64: AGENTS_EMPTY_PICTURE
      })
    },
    /**
     * Lance la capture photo
     * Affiche une erreur si cordova est absent
     * Retourne un mock en DEV
     *
     * @public
     */
    captureImage () {
      if (this.$q.platform.is.cordova) {
        navigator.camera.getPicture(
          base64 => { // on success
            this.$emit('input', { mimeType: `image/jpeg`, base64: `data:image/jpeg;base64,${base64}` })
          },
          () => { // on fail
            if (process.env.DEV) {
              this._emitBouchon()
            }
            this.$q.notify(`Impossible d'accéder à la camera !`)
          },
          {
            destinationType: 0
          })
      } else {
        this.cameraOpen()
      }
    },
    async cameraOpen () {
      try {
        this._clearStream()
        this.stream = await navigator.mediaDevices.getUserMedia(
          {
            video: {
              facingMode: this.frontCamera ? 'user' : 'environment'
            },
            audio: false
          })
        this.showPhotoModal = true
        this.$nextTick(() => {
          const $video = this.$refs.video
          if ('srcObject' in $video) {
            $video.srcObject = this.stream
          } else {
            $video.src = window.URL.createObjectURL(this.stream)
          }
          $video.onloadedmetadata = () => {
            $video.play()
          }
        })
      } catch (e) {
        if (process.env.DEV) {
          this._emitBouchon()
        } else {
          this.$q.notify(`Impossible d'accéder à la caméra`)
        }
      }
    },
    async cameraCapture () {
      // Cette méthode est encore expérimentale mais prometteuse !
      // try {
      //   const imageCaptureConfig = this.flash
      //     ? {
      //       fillLightMode: 'flash', /* or "flash" */
      //       focusMode: 'continuous'
      //     }
      //     : {}
      //   const track = this.stream.getVideoTracks()[0]
      //   const imageCapture = new ImageCapture(track)
      //   const blob = await imageCapture.takePhoto(imageCaptureConfig)
      //   const reader = new FileReader()
      //   reader.onload = (e) => {
      //     this.$emit('input', {
      //       mimeType: blob.type,
      //       base64: e.target.result
      //     })
      //   }
      //   reader.readAsDataURL(blob)
      // } catch (e) {
      // Fallback pour les navigateurs qui sans `ImageCapture`
      const $video = this.$refs.video
      const $canvas = document.createElement('canvas')
      const { videoHeight, videoWidth } = $video
      $canvas.height = videoHeight
      $canvas.width = videoWidth
      const context = $canvas.getContext('2d')
      context.drawImage($video, 0, 0, videoWidth, videoHeight)
      const data = $canvas.toDataURL('image/jpeg')
      this.$emit('input', {
        mimeType: `image/jpeg`,
        base64: data
      })
      // }
      this.cameraClose()
    },
    cameraClose () {
      this._clearStream()
      this.showPhotoModal = false
    },
    cameraRotate () {
      this.frontCamera = !this.frontCamera
      this.cameraOpen()
    }
  }
}
</script>

<style scoped>

</style>
